// extracted by mini-css-extract-plugin
export default {"row":"HRPanel_row__r3P48"};